import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PixelImage extends Component {
    constructor(props) {
        super(props);
    }
    shouldComponentUpdate(nextProps) {
        const { props } = this;
        if(props.track != nextProps.track || props.src != nextProps.src) {
            return true;
        }
        return false;
    }
    render() {
        const { track, src } = this.props;
        const { Date } = window;
        if (track === false || src.trim() === "") {
            return null;
        } else {
            const imgSrc = src.replace("[timestamp]", (new Date()).getTime());
            //console.log("[PixelImage] imgSrc:", imgSrc);

            return (
                <img src={imgSrc} />
            )
        }
    }
    static get propTypes() {
        return {
            "track": PropTypes.bool,
            "src": PropTypes.string
        }
    }

    static get defaultProps() {
        return {
            "track": true,
            "src": ""
        }
    }
}
export default PixelImage;